import React, { useState, useEffect, useRef } from "react";
import { gl_start, registerSceneHMR, setUniform } from "./webgl0.js";

function Scene() {
this.vertexShader = `#version 300 es
in vec3 aPos;
out vec3 vPos;

void main() {
  gl_Position = vec4(aPos, 1.0);
  vPos = aPos;
}`;

this.fragmentShader = `#version 300 es
precision mediump float;

in vec3 vPos;
out vec4 fragColor;

uniform float uTime;

// HASH FUNCTION TO MAKE PSEUDO RANDOM VALUES
float hash(vec2 p) {  // Takes vec2 input
  return fract(sin(dot(p, vec2(12.9898, 78.233))) * 43758.5453);
}  // Returns float output (0.0 to 1.0)

void main() {
  // DEFINE Z POSITION
  float z = sqrt(1.0 - vPos.x*vPos.x - vPos.y*vPos.y);
  vec3 P = vec3(vPos.x, vPos.y, z);

  // CREATE MOVING LIGHT
  float speed = 1.0;
  float amplitude = 4.0;

  vec3 L = vec3(
    cos(uTime * speed) * amplitude,
    0,
    sin(uTime * speed) * amplitude
  );

  // vec3 L = vec3(0.0, 0.0 ,1.0);

  fragColor = vec4(0.0, 0.0, 0.0, 1.0);

  if(P.z > 0.0) {
    // COMPUTE DIFFUSE LIGHTING
    float cosineValue = dot(P, L); // surface normal is P
    float diffused = max(0.0, cosineValue);

    vec2 center = vec2(0.0, 0.0);
    
    // CREATE GRID
    float gridSize = 10.0; // Higher = more dots
    vec2 gridPos = vPos.xy * gridSize;
    vec2 cellId = floor(gridPos);
    vec2 cellUV = fract(gridPos); // local coordinate 0.0 - 0.1
    
    // Generate multiple dots per cell
    int no = 30;

    for(int i = 0; i < no; i++) {
      // POSITION DOTS RANDOMLY IN CELL
      vec2 offsetX = vec2(float(i), 0.0);
      vec2 offsetY = vec2(0.0, float(i));

      float randomX = hash(cellId + offsetX);
      float randomY = hash(cellId + offsetY);
      
      vec2 dotPos = vec2(randomX, randomY);

      // ANIMATION LOGIC
      // float threshold = diffused;
      float threshold = diffused * 0.8 + 0.2;

      bool condition = randomX < threshold;
      // bool condition = randomY < threshold || randomX < threshold;


      // DRAW DOTS
      float dist = length(cellUV - dotPos);
      // float dist = length(center - dotPos);

      float dotSize = 0.05;
      // float dotSize = length(center - dotPos) * 0.1;
      // float dotSize = P.z * 0.1;

      if(dist < dotSize && condition) {
        fragColor.rgb = vec3(1.0);
        fragColor.a = diffused + 0.2;
      }


      // DRAW LINE
      // // float dist = abs(cellUV.y - dotPos.y); // horizontal line
      // float lineThickness = 0.05 + sin(uTime) * 0.025;            // smaller = thinner line

      // // ex. 45 degrees
      // vec2 rotated = vec2(
      //   dot(cellUV - dotPos, normalize(vec2(1.0, 1.0))),
      //   dot(cellUV - dotPos, normalize(vec2(-1.0, 1.0)))
      // );

      // float dist = abs(rotated.x);

      // if(dist < lineThickness && condition) {
      //   fragColor.rgb = vec3(1.0);
      //   fragColor.a = P.z;
      // }


    }
  }
}
`;

  let startTime = Date.now() / 1000;

  this.update = () => {
    setUniform('1f', 'uTime', Date.now() / 1000 - startTime);
  };
}

export default function WebGLCanvas() {
  const canvasRef = useRef(null);
  const [scene, setScene] = useState(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    try { if (typeof canvas.stopRender === 'function') canvas.stopRender(); } catch (e) {}

    const newScene = new Scene();

    gl_start(canvas, newScene);
    setScene(newScene);

    try { registerSceneHMR(module, canvas, () => new Scene()); } catch (e) { /* ignore in non-HMR env */ }
    return () => { try { if (typeof canvas.stopRender === 'function') canvas.stopRender(); } catch (e) {} };
  }, []);

  return (
    <div style = { { display: "flex", justifyContent: "center", gap : "1px" } }>
        <canvas ref={canvasRef} width={400} height={400} style={{ width : "400px", height : "400px", display: "block", margin: "0 auto", background: "black" }} />
        <pre className = "codeblock-shader">{ scene?.fragmentShader }</pre>
    </div>
  );
}
